"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParticipantFieldIds = exports.hasDependencyProducts = exports.hasDependencyActivities = exports.evaluateDependencies = exports.evaluateDependency = exports.buildSearchObject = void 0;
const activity_lib_1 = require("@azavista/activity-lib");
const search_converter_1 = require("../search-converter");
const object_matches_search_1 = require("../object-matches-search");
const buildSearchObject = (participant, event, participantActivities, shoppingCartResult, workflow, eventSettings) => {
    const searchObj = {};
    Object.keys(participant).forEach((key) => {
        searchObj[`Participant_${key}`] = participant[key];
    });
    Object.keys(event).forEach((key) => {
        searchObj[`Event_${key}`] = event[key];
    });
    searchObj[`Workflow_waitlist`] = workflow['waitlist'];
    searchObj[`Workflow_payment`] = workflow['payment'];
    searchObj[`Workflow_payment_method`] = workflow['payment_method'];
    searchObj[`ParticipantActivity_ids`] = participantActivities
        .filter((a) => {
        const status = a.activity_participant_status;
        if (status === activity_lib_1.ActivityParticipantStatus.ARRIVED) {
            return true;
        }
        if (status === activity_lib_1.ActivityParticipantStatus.NO_SHOW) {
            return true;
        }
        if (a.renderas) {
            return [
                activity_lib_1.ActivityParticipantStatus.REGISTERED,
                activity_lib_1.ActivityParticipantStatus.ARRIVED,
                activity_lib_1.ActivityParticipantStatus.NO_SHOW,
            ].includes(a.renderas);
        }
        return status === activity_lib_1.ActivityParticipantStatus.REGISTERED;
    })
        .map((pa) => pa.id);
    searchObj[`Product_ids`] = shoppingCartResult.condensedItems
        .filter((p) => p.product?.id && p.quantity > 0)
        .map((p) => p.product.id);
    searchObj[`Product_limit_reached`] = shoppingCartResult.condensedItems
        .filter((p) => p.product?.max_per_buyer <= p.quantity)
        .map((p) => p.product.id);
    searchObj[`Product_ticket_count`] = shoppingCartResult.condensedItems
        .filter((p) => p.product?.type === 'ticket')
        .reduce((val, p) => {
        return val + p.quantity;
    }, 0);
    searchObj['Product_total_price'] = shoppingCartResult.totals.total;
    searchObj[`EventSettings_access`] = eventSettings['access'];
    searchObj[`EventSettings_publish`] = eventSettings['publish'];
    searchObj[`EventSettings_last_registration_date`] =
        eventSettings['last_registration_date'];
    searchObj[`EventSettings_publication_date`] =
        eventSettings['publication_date'];
    searchObj[`EventSettings_offline_date`] = eventSettings['offline_date'];
    return searchObj;
};
exports.buildSearchObject = buildSearchObject;
const evaluateDependency = (dependency, participant, event, participantActivities, shoppingCartResult, workflow, eventSettings) => {
    const searchObj = (0, exports.buildSearchObject)(participant, event, participantActivities, shoppingCartResult, workflow, eventSettings);
    const searchParams = (0, search_converter_1.flatSearchToRecursiveWithOR)(dependency.criteria, 'id');
    return (0, object_matches_search_1.objectMatchesSearch)(searchObj, searchParams);
};
exports.evaluateDependency = evaluateDependency;
const evaluateDependencies = (dependencies, participant, event, participantActivities, shoppingCartResult, workflow, eventSettings) => {
    const searchObj = (0, exports.buildSearchObject)(participant, event, participantActivities, shoppingCartResult, workflow, eventSettings);
    return dependencies.reduce((res, dependency) => {
        const searchParams = (0, search_converter_1.flatSearchToRecursiveWithOR)(dependency.criteria, 'id');
        res[dependency.id] = (0, object_matches_search_1.objectMatchesSearch)(searchObj, searchParams);
        return res;
    }, {});
};
exports.evaluateDependencies = evaluateDependencies;
const hasDependencyActivities = (dependencies) => {
    for (const dep of dependencies) {
        for (const or of dep.criteria) {
            for (const item of or) {
                if (item.field.id === 'ParticipantActivity_ids') {
                    return true;
                }
            }
        }
    }
    return false;
};
exports.hasDependencyActivities = hasDependencyActivities;
const hasDependencyProducts = (dependencies) => {
    for (const dep of dependencies) {
        for (const or of dep.criteria) {
            for (const item of or) {
                if (item.field.id === 'Product_ids') {
                    return true;
                }
            }
        }
    }
    return false;
};
exports.hasDependencyProducts = hasDependencyProducts;
const getParticipantFieldIds = (dependencies) => {
    const ids = [];
    for (const dep of dependencies) {
        for (const or of dep.criteria) {
            for (const item of or) {
                if (item.field.id.startsWith('Participant_')) {
                    ids.push(item.field.id.replace('Participant_', ''));
                }
            }
        }
    }
    return ids;
};
exports.getParticipantFieldIds = getParticipantFieldIds;
